import * as React from "react"
const SvgClock = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 12.028v-3.6a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.287.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713v3.974q0 .2.075.388.075.187.225.338l3.3 3.3a.95.95 0 0 0 .7.274.95.95 0 0 0 .7-.274.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7zm-1 10.4a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.176a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.174q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787 9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.174q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.788Zm0-2q3.325 0 5.663-2.337 2.336-2.337 2.337-5.663 0-3.325-2.337-5.662T12 4.429c-3.325 0-4.104.779-5.662 2.337Q4 9.104 4 12.428q0 3.326 2.338 5.663T12 20.428" />
  </svg>
)
export default SvgClock
